module.exports = __webpack_public_path__ + "static/gallery-12@2x-e973a38071480d07e9b5b9bbdcabdeaa.jpg";